import React from 'react';
import { Footer } from '../Common/Footer';
import Pagination from "react-js-pagination";
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import { AffiliatorDashboardHeader } from '../Common/AffiliatorDashboardHeader';
import { Header } from '../Common';
import StarRatings from 'react-star-ratings';
import "bootstrap/scss/bootstrap.scss";
class PurchaseProducts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: false,
        };
    }

    handlePageChange() {
        console.log("asasd");
    }

    render() {
        return (
            <div>
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="col-md-12 tr_blank_medium mt-5 "></div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12 mb-3">
                            <div className="row">
                                <div className="col-md-0">

                                </div>

                                <div className="col-md-4 input_name">
                                    <AffiliatorSidebar />
                                </div>

                                <div className="col-md-8">
                                    <div className="mt-5 mb-3 input_name big_font guide_text">
                                        Buyer Dashboard
                                    </div>
                                    <div style={{ height: "auto", backgroundColor: "#f2f4f7" }}>
                                        <div className="custom_padding_dash">
                                            <div className="row">
                                                <div className="col-md-12 diff_border">
                                                    <div className="row">
                                                        <div className="col-md-2 mini_pad">
                                                            <img src={require("../../assets/images/image1.jpeg")} className=" rounded-circle" alt="" width="100%" height="70%" /><br />
                                                            <div className="special_padd"><img src={require("../../assets/images/pro.png")} className="" alt="" width="30%" height="36%" /></div>
                                                        </div>
                                                        <div className="col-md-7 remember_text">
                                                            <span><b>Design a simple and stylish logo</b></span><br />
                                                            <span className="diff_font">Provide a sophisticated image with a concept!</span>
                                                            <div className="design_text">
                                                                design
                                                                                </div>
                                                            <div className="product_description">
                                                                A logo is identity = uniqueness, and it needs to be recognized visually. In addition, if it is high-class one,
                                                                it looks high and has dignity. If it is cheap, it should be friendly. See details ...
                                                                                </div>
                                                            <div className="mt-4 stars">
                                                                <b>by</b> Sabik Safkat &nbsp;&nbsp;
                                                                <StarRatings
                                                                    rating={3.8}
                                                                    starDimension="15px"
                                                                    starSpacing="1px"
                                                                    starRatedColor="#FFD700"
                                                                />
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                            <b>60,000 USD</b>
                                                            </div>
                                                            <div className="amount">
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <img src={require("../../assets/images/image1.jpeg")} alt="" width="100%" height="100%" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>

                                        </div>
                                    </div>
                                    <div style={{ height: "auto", backgroundColor: "#f2f4f7" }}>
                                        <div className="custom_padding_dash">
                                            <div className="row">
                                                <div className="col-md-12 diff_border">
                                                    <div className="row">
                                                        <div className="col-md-2 mini_pad">
                                                            <img src={require("../../assets/images/image1.jpeg")} className=" rounded-circle" alt="" width="100%" height="70%" /><br />
                                                            <div className="special_padd"><img src={require("../../assets/images/pro.png")} className="" alt="" width="30%" height="36%" /></div>
                                                        </div>
                                                        <div className="col-md-7 remember_text">
                                                            <span><b>Design a simple and stylish logo</b></span><br />
                                                            <span className="diff_font">Provide a sophisticated image with a concept!</span>
                                                            <div className="design_text">
                                                                design
                                                                                </div>
                                                            <div className="product_description">
                                                                A logo is identity = uniqueness, and it needs to be recognized visually. In addition, if it is high-class one,
                                                                it looks high and has dignity. If it is cheap, it should be friendly. See details ...
                                                                                </div>
                                                            <div className="mt-4 stars">
                                                                <b>by</b> Sabik Safkat &nbsp;&nbsp;

                                                                <StarRatings
                                                                    rating={3.8}
                                                                    starDimension="15px"
                                                                    starSpacing="1px"
                                                                    starRatedColor="#FFD700"
                                                                />
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                            <b>60,000 USD</b>
                                                            </div>
                                                            <div className="amount">
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <img src={require("../../assets/images/image1.jpeg")} alt="" width="100%" height="100%" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>

                                        </div>
                                    </div>
                                    <div style={{ height: "auto", backgroundColor: "#f2f4f7" }}>
                                        <div className="custom_padding_dash">
                                            <div className="row">
                                                <div className="col-md-12 diff_border">
                                                    <div className="row">
                                                        <div className="col-md-2 mini_pad">
                                                            <img src={require("../../assets/images/image1.jpeg")} className=" rounded-circle" alt="" width="100%" height="70%" /><br />
                                                            <div className="special_padd"><img src={require("../../assets/images/pro.png")} className="" alt="" width="30%" height="36%" /></div>
                                                        </div>
                                                        <div className="col-md-7 remember_text">
                                                            <span><b>Design a simple and stylish logo</b></span><br />
                                                            <span className="diff_font">Provide a sophisticated image with a concept!</span>
                                                            <div className="design_text">
                                                                design
                                                                                </div>
                                                            <div className="product_description">
                                                                A logo is identity = uniqueness, and it needs to be recognized visually. In addition, if it is high-class one,
                                                                it looks high and has dignity. If it is cheap, it should be friendly. See details ...
                                                                                </div>
                                                            <div className="mt-4 stars">
                                                                <b>by</b> Sabik Safkat &nbsp;&nbsp;

                                                                <StarRatings
                                                                    rating={3.8}
                                                                    starDimension="15px"
                                                                    starSpacing="1px"
                                                                    starRatedColor="#FFD700"
                                                                />
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                            <b>60,000 USD</b>
                                                            </div>
                                                            <div className="amount">
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <img src={require("../../assets/images/image1.jpeg")} alt="" width="100%" height="100%" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>

                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3"></div>
                                        <div className="col-md-6 ">

                                            <Pagination
                                                hideNavigation
                                                activePage={this.state.activePage}
                                                itemsCountPerPage={10}
                                                totalItemsCount={450}
                                                pageRangeDisplayed={5}
                                                onChange={this.handlePageChange.bind(this)}
                                            />
                                        </div>
                                        <div className="col-md-3"></div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
export { PurchaseProducts }